import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  age: number;
  city: string;
}
export function TestimonialCard({
  quote,
  name,
  age,
  city
}: TestimonialCardProps) {
  return <div className="bg-white p-8 rounded-3xl shadow-sm border-2 border-navy/10 h-full flex flex-col" data-id="element-212">
      <div className="flex gap-1 mb-4" data-id="element-213">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-gold text-gold" data-id="element-214" />)}
      </div>

      <div className="flex-grow mb-6" data-id="element-215">
        <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-216">
          "{quote}"
        </p>
      </div>

      <div className="border-t border-navy/10 pt-4 mt-auto" data-id="element-217">
        <p className="font-bold text-navy" data-id="element-218">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-219">
          {age} años, {city}
        </p>
      </div>
    </div>;
}